/* eslint-disable @typescript-eslint/no-explicit-any */
const cache = new WeakMap()

class Timer {
  private _t?: ReturnType<typeof setTimeout>
  public getTimer = () => this._t
  public setTimer = (t: ReturnType<typeof setTimeout>) => {
    this._t = t
  }
}

const getCacheTimer = (fn: any): Timer => {
  if (!cache.has(fn)) {
    cache.set(fn, new Timer())
  }

  return cache.get(fn)
}

export default function (
  fn: (...args: any[]) => void,
  period = 500
): [(...args: any[]) => void, () => void] {
  const timer = getCacheTimer(fn)
  const t = timer.getTimer()
  // eslint-disable-next-line no-console
  // console.log(`execute-when-change-stop invoked timer: ${t}`)
  return [
    period
      ? (...args: any[]) => {
          if (t) {
            clearTimeout(t)
          }
          timer.setTimer(
            setTimeout(() => {
              // eslint-disable-next-line no-console
              // console.log('execute-when-change-stop execute function')
              fn(...args)
            }, period)
          )
        }
      : fn,
    () => {
      if (t) {
        clearTimeout(t)
      }
    }
  ]
}
